import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

let nextId = 0;

/**
 * Destructive-action confirmation modal.
 * The parent controls visibility with @if and projects the title ([dialogTitle]) and message.
 */
@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '(document:keydown.escape)': 'cancel()',
  },
})
export class ConfirmDialogComponent {
  readonly confirmLabel = input('Confirm');
  readonly cancelLabel = input('Cancel');
  /** While busy, buttons are disabled and the dialog can't be dismissed. */
  readonly busy = input(false);
  readonly busyLabel = input('Working…');
  readonly error = input<string | null>(null);

  readonly confirmed = output<void>();
  readonly cancelled = output<void>();

  protected readonly titleId = `confirm-dialog-title-${nextId++}`;

  protected cancel(): void {
    if (!this.busy()) this.cancelled.emit();
  }

  protected confirm(): void {
    if (!this.busy()) this.confirmed.emit();
  }
}
